import { render } from "./StatusesListAddModal.vue?vue&type=template&id=b8c17aa6"
import script from "./StatusesListAddModal.vue?vue&type=script&lang=js"
export * from "./StatusesListAddModal.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__